import React, { PropTypes } from 'react'
import styles from './index.css'


function Indicator ({ current, statuses, onChange }) {

  return (
    <div className={styles.root}>
      {
        statuses.map((status, index) => {
          let style = status ? styles.correct : styles.incorrect
          if (current === index) {
            style = `${styles.blockActive} ${style}`
          }
          return (
            <div
              className={style}
              key={index}
              onClick={() => current !== index && onChange(index)}
            >
              { index + 1 }
            </div>
          )
        })
      }
    </div>
  )
}

Indicator.propTypes = {
  statuses: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired
  ).isRequired,
  current: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Indicator



/** WEBPACK FOOTER **
 ** ./src/components/Common/Indicator/index.js
 **/